import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles/CategoryManagementPage.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getMyPurchasesAction,
  deleteCourseAction,
  getAllCategoriesAction,
} from "@redux/actions";
import { ModalConfirm } from "@components/Modal/ModalConfirm";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { TableCustom } from "@components";
import { Container } from "react-bootstrap";

const CategoryManagementPage = (props) => {
  // state
  const dispatch = useDispatch();
  const { allCategories } = useSelector((state) => state.category);
  console.log(allCategories);
  useEffect(() => {
    dispatch(getAllCategoriesAction());
  }, []);

  const [show, setShow] = useState(false);
  const [id, setId] = useState("");

  const handleShowEdit = () => setShow(true);
  const deleteCourse = () => {
    dispatch(deleteCourseAction({ id: id, type: "course" }));
  };
  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials
  const columns = [
    {
      title: "Item No.",
      dataIndex: "itemNo",
    },
    // {
    //   title: "Id",
    //   dataIndex: "id",
    //   render: (id) => {
    //     return id;
    //   },
    // },
    {
      title: "Category",
      dataIndex: "name",
      render: (name) => {
        return (
          <Link to={"/category-management/"} className="text-decoration-none">
            {name}
          </Link>
        );
      },
    },
    // {
    //   title: "Delivery Type",
    //   dataIndex: "id",
    //   render: () => {
    //     // dataIndex: "deliveryType",
    //     // render: (deliveryType) => {
    //     return <strong className="text-danger">Download</strong>;
    //     // return <strong className="text-danger">{deliveryType}</strong>;
    //   },
    // },
    {
      title: "Subcategories",
      dataIndex: "subCategories",
      render: (subCategories, item) => {
        console.log(item);
        return subCategories.length;
      },
    },

    {
      title: "Actions",
      dataIndex: "id",
      render: (id) => {
        return (
          <div>
            {/* <i className={clsx("bi bi-download", styles.icon)}></i> */}
            <i
              className={clsx("bi bi-pencil-square", styles.icon)}
              onClick={() => {
                setId(id);
                // handleShow();
              }}
            ></i>
            {/* <i className={clsx("bi bi-printer ml-2", styles.icon)}></i> */}
          </div>
        );
      },
    },
  ];
  // effects

  // render
  return (
    <Container className="pt-5">
      <TableCustom
        columns={columns}
        dataSource={allCategories.data}
        isLoading={allCategories.processing}
      />
    </Container>
  );
};

/* required: display name */
CategoryManagementPage.displayName = "CategoryManagementPage";

/* required: props types */
CategoryManagementPage.propTypes = {};

/* required: default props */
CategoryManagementPage.defaultProps = {};

export { CategoryManagementPage };
